import { v4 as uuidv4 } from 'uuid'
import { ItemState } from '../types/api'
import type { TransactionRow } from '../types/transactions'

export const isTransactionRowFilled = (row: TransactionRow) => {
  const hasFustcode = typeof row.fustCode === 'number' && row.fustCode > 0
  const hasQuantity =
    (typeof row.stapelwagens === 'number' && row.stapelwagens > 0) ||
    (typeof row.stapels === 'number' && row.stapels > 0) ||
    (typeof row.stuks === 'number' && row.stuks > 0)

  return hasFustcode && hasQuantity
}

export const createTransactionRow = (): TransactionRow => ({
  id: uuidv4(),
  // Leave optional numeric fields undefined so a freshly created row is not
  // considered "filled" by `isTransactionRowFilled`.
  itemState: ItemState.Clean,
})

export const addTransactionRow = (transactions: TransactionRow[]) => {
  const newRow = createTransactionRow()

  return {
    transactions: [...transactions, newRow],
    newRowId: newRow.id,
  }
}

export const removeTransactionRow = ({
  transactions,
  id,
}: {
  transactions: TransactionRow[]
  id: string
}) => {
  if (transactions.length === 1) {
    return transactions
  }

  return transactions.filter(transaction => transaction.id !== id)
}

export const updateTransactionRow = ({
  transactions,
  id,
  updates,
}: {
  transactions: TransactionRow[]
  id: string
  updates: Partial<Omit<TransactionRow, 'id'>>
}) =>
  transactions.map(transaction =>
    transaction.id === id ? { ...transaction, ...updates } : transaction
  )
